import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ['hide']

  hideForm() {
    $(this.hideTarget).fadeOut(500)
  }

  removeForm() {
    $(this.hideTarget).fadeOut(500).remove()
    if ($('#make-ready-notes').length) {
      this.handleMakeReadyElements()
    }
  }

  handleMakeReadyElements() {
    $('#add-note').show().fadeIn('slow')
    if ($('.make-ready-item-note').length == 0) {
      $('#no-results-note').removeClass('d-none')
    }
  }

  // Checks if click is outside element
  clickOutsideElement(e) {
    if (e.target.type != 'submit') {
      e.preventDefault()
      // if click is on or inside element then return
      if (this.element == e.target || this.element.contains(e.target)) return;

      this.replaceFormWithComment()
    }
  }

  // if click is outside element, remove element and show original unedited comment
  replaceFormWithComment() {
    const id = $(this.hideTarget).data('id')
    $(this.hideTarget).remove()
    $(`#post-comment-${id}`).addClass('d-flex').show()
  }
}